export const actionType = {
    // HOME PAGE
    FET_MOVIE_HOME_REQUEST : 'FET_MOVIE_HOME_REQUEST',
    FET_MOVIE_HOME:'FET_MOVIE_HOME',
    FET_MOVIE_HOME_FAILED:'FET_MOVIE_HOME_FAILED',
    // DETAIL MOVIES 
    SELECTED_MOVIES_REQUEST :'SELECTED_MOVIES_REQUEST',
    SELECTED_MOVIES : 'SELECTED_MOVIES',
    SELECTED_FAILED : 'SELECTED_FAILED',
    // REMOVE DATA
    REMOVE_MOVIE :'REMOVE_MOVIE',
    // GENRE
    FET_GENRE_REQUEST: 'FET_GENRE_REQUEST',
    FET_GENRE :'FET_GENRE',
    FET_GENRE_FAILED:'FET_GENRE_FAILED',
    // SEARCH MOVIE
    SEARCH_MOVIES_REQUEST :'SEARCH_MOVIES_REQUEST',
    SEARCH_MOVIES: 'SEARCH_MOVIES',
    SEARCH_FAILED : 'SEARCH_FAILED',
    // SIMILAR MOVIES
    SIMILAR_MOVIES_REQUEST :'SIMILAR_MOVIES_REQUEST',
    SIMILAR_MOVIES_SUCCESS:'SIMILAR_MOVIES_SUCCESS',
    SIMILAR_MOVIES_FAILED:'SIMILAR_MOVIES_FAILED',
    // BROWSE MOVIES
    BROWSE_MOVIES_REQUEST:'BROSER_MOVIES_REQUEST',
    BROWSE_MOVIES_SUCCESS:'BROSER_MOVIES_SUCCESS',
    BROWSE_MOVIES_FAILED:'BROSER_MOVIES_FAILED',
    BROWSE_MOVIES_REMOVE:'BROWSE_MOVIES_REMOVE'
}

